import cx from 'classnames';
import { Link, Tabs, Text, useGeneratePath, useStaticUrls } from 'platform-components';
import React from 'react';
import ym from 'react-yandex-metrika';

import { COURSE_VIEW_LESSONS_TABS } from '../typings';

interface Props {
    lessonsCounters: Record<'complete' | 'active' | 'drafts', number | undefined>;
    currentTab: COURSE_VIEW_LESSONS_TABS;
    isClosed: boolean;
    /** отключает редиректы на табах */
    disableRouter?: boolean;
    /** в функцию прокидывается текущее значение таба, по которому совершен клик */
    onTabClick?: (tab: COURSE_VIEW_LESSONS_TABS) => void;
}

export const CourseViewLessonsTabs = ({ lessonsCounters, currentTab, isClosed, onTabClick, disableRouter }: Props) => {
    const getRouterPath = useGeneratePath();
    const staticUrls = useStaticUrls();

    const handleClickCompleteTab = () => {
        onTabClick?.(COURSE_VIEW_LESSONS_TABS.COMPLETE);
        ym('reachGoal', 'lessons_tabs_completed');
    };

    const handleClickActiveTab = () => {
        onTabClick?.(COURSE_VIEW_LESSONS_TABS.ACTIVE);
        ym('reachGoal', 'lessons_tabs_inprogress');
    };

    const handleClickDraftsTab = () => {
        onTabClick?.(COURSE_VIEW_LESSONS_TABS.DRAFTS);
        ym('reachGoal', 'lessons_tabs_notissued');
    };

    return (
        <div className="course-view__lessons-tabs">
            <Tabs>
                <Link
                    isRouter
                    mix="course-view__lessons-tabs-link"
                    pseudo={disableRouter}
                    theme={Link.THEME.INHERIT}
                    to={disableRouter ? undefined : getRouterPath(staticUrls.labSubjectLessonsComplete)}
                >
                    <Tabs.Tab
                        counter={lessonsCounters.complete}
                        id={COURSE_VIEW_LESSONS_TABS.COMPLETE}
                        mix={cx('course-view__lessons-tab', 'qa_course-view-tab-complete')}
                        onTabSelect={handleClickCompleteTab}
                        selected={currentTab === COURSE_VIEW_LESSONS_TABS.COMPLETE}
                    >
                        <Text id="courseView.tabs.complete" />
                    </Tabs.Tab>
                </Link>
                {isClosed ? null : (
                    <Link
                        isRouter
                        mix="course-view__lessons-tabs-link"
                        pseudo={disableRouter}
                        theme={Link.THEME.INHERIT}
                        to={disableRouter ? undefined : getRouterPath(staticUrls.labSubjectLessonsActive)}
                    >
                        <Tabs.Tab
                            counter={lessonsCounters.active}
                            id={COURSE_VIEW_LESSONS_TABS.ACTIVE}
                            mix={cx('course-view__lessons-tab', 'qa_course-view-tab-active')}
                            onTabSelect={handleClickActiveTab}
                            selected={currentTab === COURSE_VIEW_LESSONS_TABS.ACTIVE}
                        >
                            <Text id="courseView.tabs.active" />
                        </Tabs.Tab>
                    </Link>
                )}
                {isClosed ? null : (
                    <Link
                        isRouter
                        mix="course-view__lessons-tabs-link"
                        pseudo={disableRouter}
                        theme={Link.THEME.INHERIT}
                        to={disableRouter ? undefined : getRouterPath(staticUrls.labSubjectLessonsDrafts)}
                    >
                        <Tabs.Tab
                            counter={lessonsCounters.drafts}
                            id={COURSE_VIEW_LESSONS_TABS.DRAFTS}
                            mix={cx('course-view__lessons-tab', 'qa_course-view-tab-drafts')}
                            onTabSelect={handleClickDraftsTab}
                            selected={currentTab === COURSE_VIEW_LESSONS_TABS.DRAFTS}
                        >
                            <Text id="courseView.tabs.draftsTab" />
                        </Tabs.Tab>
                    </Link>
                )}
            </Tabs>
        </div>
    );
};
